<template>
  <v-textarea
    v-bind="$attrs"
    v-on="$listeners"
    :rows="rows"
    :row-height="rowHeight"
    :counter="counter"
    :outlined="outlined"
    :readonly="readonly"
  />
</template>

<script>
export default {
  name: 'AdsTextArea',
  props: {
    rows: {
      type: [Number, String],
      default: '4'    // override the default value '5' in v-textarea
    },
    rowHeight: {
      type: [Number, String],
      default: '20'   // override the default value '24' in v-textarea
    },
    counter: {
      type: [Number, String, Boolean],
      default: '100'  // override the default value 'undefined' in v-textarea
    },
    outlined: {
      type: Boolean,  // override the default value 'false' in v-textarea
      default: true
    },
    readonly: {
      type: Boolean,  // override the default value 'false' in v-textarea
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/ads.scss";

.v-application .error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep div.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep label.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep button.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep i.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}
</style>
